import { Card, CardContent } from "@/shared/ui/card";
import { Select } from "@/shared/widgets/select";
import { Label } from "@/shared/ui/label";
import { UnifiedUpload } from "@/shared/ui/UnifiedUpload";
import { CoverType } from "@/features/learnings/service/learningService";

interface Props {
    formData: any;
    setFormData: React.Dispatch<React.SetStateAction<any>>;
    handleCoverUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
    id: string;
    isLoadingCreators: boolean;
    creators: { id: string; name: string; avatar: string }[];
    validationErrors?: Record<string, string>;
    clearFieldError?: (field: string) => void;
}

export const CoverSection: React.FC<Props> = ({ 
    formData, 
    setFormData, 
    handleCoverUpload, 
    id, 
    isLoadingCreators, 
    creators,
    validationErrors = {},
    clearFieldError
}) => (
    <Card className="bg-white/[0.03] border-white/[0.06]">
        <CardContent className="pt-6">
            <div className="space-y-4">
                <h3 className="text-lg font-medium text-white">
                    Imagem de Capa *
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                        <Label className="text-white">Upload da Imagem</Label>
                        <UnifiedUpload
                            id={`before-${id}`}
                            title="Capa do artigo"
                            preview={formData.cover}
                            onFileChange={(e) => {
                                handleCoverUpload(e);
                                clearFieldError?.('cover');
                            }}
                            showRemoveButton={true}
                            onRemove={() => { setFormData({ ...formData, cover: null }) }}
                            acceptTypes="image/*"
                            variant="cover"
                            enableDragDrop={false}
                            maxSizeMB={0.5}
                            error={!!validationErrors.cover}
                            errorMessage={validationErrors.cover}
                        />
                    </div>

                    <div>
                        <div className="space-y-2">
                            <Label htmlFor="coverType" className="text-white">Tipo da Capa</Label>
                            <Select
                                className="w-full"
                                value={formData.coverType}
                                onChange={(value: CoverType) =>
                                    setFormData({ ...formData, coverType: value })
                                }
                                data={[
                                    { value: 'IMAGE', label: 'Imagem' },
                                    { value: 'VIDEO', label: 'Vídeo' },
                                ]}
                            />
                        </div>
                        <div className="space-y-2 mt-4">
                            <Label htmlFor="creator" className="text-white">
                                Criador *
                            </Label>
                            <Select
                                className="w-full"
                                value={formData.creatorId}
                                onChange={(value: string) => {
                                    setFormData({ ...formData, creatorId: value });
                                    clearFieldError?.('creatorId');
                                }}
                                data={creators?.map(creator => ({
                                    value: creator.id,
                                    label: creator.name,
                                    image: creator.avatar
                                })) || []}
                                placeholder={isLoadingCreators ? 'Carregando criadores...' : 'Selecione um criador'}
                                size="lg"
                                error={!!validationErrors.creatorId}
                                errorMessage={validationErrors.creatorId}
                            />
                            {!isLoadingCreators && (!creators || creators.length === 0) && (
                                <p className="text-sm text-yellow-400">Nenhum criador encontrado. Por favor, crie um criador primeiro.</p>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </CardContent>
    </Card>
);
